import { Box, IconButton, Typography } from "@mui/material";
import pdfIcon from "app/components/FileUpload/assets/pdf.svg";
import { DeleteIcon, UpArrowIcon } from "app/icons";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { FileType } from "utils/enum";
import { ValidateFileType } from "utils/helpers";

import { useStyles } from "./styles";

const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;
const P = "COMMON.FILE_INPUT";
type file = {
    name: string;
    url: string;
  }

export interface Props {
  file: file | null
  dispatchFileChange: (file:file | null) => void,
  dispatchFileError: (error:string) => void,
  error: string,

}

const FileInput = 
({file,error,dispatchFileError,dispatchFileChange}:Props) => {
  const { t } = useTranslation();
  const styles = useStyles();
  
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const openFilePicker = () => fileInputRef.current?.click();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selected = event.target.files?.[0];
    if (!selected) return;

    const extension = selected.name.split(".").pop() || "";
    if (!ValidateFileType(extension, FileType.DOCUMENT)) {
      dispatchFileError(t(`${P}.ERRORS.TYPE`));
      event.target.value = "";
      return;
    }

    if (selected.size > MAX_FILE_SIZE_BYTES) {
     dispatchFileError(t(`${P}.ERRORS.SIZE`));
      event.target.value = "";
      return;
    }

    // actual upload to storage is wired up in the saga once the backend endpoint is ready
      dispatchFileChange({ name: selected.name, url: "" });
  };

  const handleRemoveFile = () => {
    dispatchFileChange(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };


  return (
    <Box>
      {file && (
        <Box className={styles.uploadedSection}>
          <Typography className={styles.label}>
            {t(`${P}.UPLOADED_LABEL`)}
          </Typography>
          <Box className={styles.fileRow}>
            <IconButton
              className={styles.deleteButton}
              onClick={handleRemoveFile}
              aria-label={t("BUTTONS.DELETE")}
            >
              <DeleteIcon />
            </IconButton>
            <Typography className={styles.fileName}>{file.name}</Typography>
            <img src={pdfIcon} alt="" className={styles.pdfIcon} />
          </Box>
        </Box>
      )}

      <Box className={styles.dropzone} onClick={openFilePicker}>
        <input
          ref={fileInputRef}
          type="file"
          hidden
          onChange={handleFileChange}
        />
        <UpArrowIcon className={styles.dropzoneIcon} />
        <Typography className={styles.dropzoneLabel}>
          {t(`${P}.DROPZONE.LABEL`)}
        </Typography>
        <Typography className={styles.dropzoneHint}>
          {t(`${P}.DROPZONE.HINT`)}
        </Typography>
      </Box>
      {error && <Typography className={styles.errorText}>{error}</Typography>}
    </Box>
  );
};

export default FileInput;
